import { makeUseAnalytics } from '@plato/app-core/hooks/make-use-analytics';
import type { ExplainableMetric } from './use-metric-copy.ts';

export type SharedAnalyticsEvents = {
    metric_hint_opened: {
        metric: ExplainableMetric;
    };
};

export const useAnalytics = makeUseAnalytics<SharedAnalyticsEvents>();
